import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from '../utils/fbpixel';
export function Offer() {
  return <section id="oferta" className="py-24 px-6 bg-white scroll-mt-10" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-brand-brown text-white rounded-[2.5rem] p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-93">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-y-1/2 translate-x-1/3" data-id="element-94"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white opacity-5 rounded-full translate-y-1/3 -translate-x-1/3" data-id="element-95"></div>

          <div className="relative z-10" data-id="element-96">
            <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 text-brand-cream" data-id="element-97">
              Recupera tus noches y tu energía hoy mismo.
            </h2>

            <p className="text-lg md:text-xl text-brand-cream/80 mb-8 max-w-2xl mx-auto" data-id="element-98">
              El acceso completo al protocolo{' '}
              <span className="font-semibold text-white" data-id="element-99">
                Sueño para BB en 7 Minutos
              </span>{' '}
              tiene una inversión única de
            </p>

            <div className="flex flex-col items-center mb-8" data-id="element-100">
              <div className="inline-flex items-center gap-3 mb-4" data-id="element-101">
                <span className="bg-brand-blue text-white text-sm md:text-base font-bold px-4 py-1.5 rounded-full uppercase tracking-wide" data-id="element-102">
                  68% de descuento
                </span>
                <span className="text-brand-cream/70 text-2xl md:text-3xl font-medium line-through" data-id="element-103">
                  $19.99
                </span>
              </div>
              <div className="bg-white text-brand-brown px-8 py-4 rounded-3xl shadow-inner" data-id="element-104">
                <span className="text-5xl md:text-7xl font-bold tracking-tight" data-id="element-105">
                  $6.36
                </span>
                <span className="text-xl md:text-2xl font-medium ml-2" data-id="element-106">
                  USD
                </span>
              </div>
              <p className="text-brand-cream/80 text-sm mt-3 font-medium" data-id="element-107">
                Oferta por tiempo limitado
              </p>
            </div>

            <p className="text-brand-cream/90 mb-10 text-lg italic" data-id="element-108">
              "Menos de lo que gastas en una cena, para una solución que
              cambiará tu vida diaria."
            </p>

            <a href="https://tuvidadigitalmejora.com/cart/51821444038977:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackAddToCart();
            trackInitiateCheckout();
          }} className="inline-block text-center w-full sm:w-auto bg-brand-blue hover:bg-brand-blue/90 text-white font-bold text-lg py-5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-brand-blue/30 mb-4" data-id="element-109">
              ¡SÍ, QUIERO QUE MI BEBÉ DUERMA YA!
            </a>

            <p className="text-sm text-brand-cream/70 flex items-center justify-center" data-id="element-110">
              <Shield className="w-4 h-4 mr-2" data-id="element-111" />
              Haz clic arriba para descargar el protocolo y aplicarlo hoy mismo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}